export const aiPersonality = {
  //  List Page
  listTitle: 'AI Voice Personality Generator',
  listSubtitle: 'Manage your AI voice personality templates',
  addPersonality: '+ Add Personality',
  personaName: 'Persona Name',
  companyName: 'Company Name',
  gender: 'Gender',
  personality: 'Personality',
  voiceSource: 'Voice Source',
  llmModel: 'LLM Model',
  updatedAt: 'Updated At',
  actions: 'Actions',
  edit: 'Edit',
  copy: 'Copy',
  delete: 'Delete',
  noData: 'No personality templates yet. Click "+ Add Personality" to create one',
  
  //  Form Page
  title: 'AI Voice Personality Generator',
  subtitle: 'Create and manage AI sales or customer service personality templates',
  backToList: 'Back to List',
  createTitle: 'Create Personality',
  editTitle: 'Edit Personality',
  
  //  Basic Info
  basicInfo: 'Basic Information',
  aiName: 'AI Name',
  aiNamePlaceholder: 'e.g., Amy',
  aiCompany: 'AI Company Name',
  aiCompanyPlaceholder: 'e.g., Real Estate Inc.',
  
  //  Gender & Personality
  genderPersonality: 'Gender & Personality',
  enthusiastic: 'Enthusiastic',
  confident: 'Confident',
  professional: 'Professional',
  humorous: 'Humorous',
  
  //  Voice Settings
  voiceSettings: 'AI Voice Settings',
  anchorVoice: 'Anchor Voice',
  cloneVoice: 'Clone Voice',
  uploadRecording: 'Upload Recording',
  uploadHint: 'Recommended recording length: about 20 seconds',
  supportedFormats: 'Supported formats: MP3 / WAV / M4A',
  fileSizeLimit: 'File size limit: 10MB',
  recordingTips: 'Tips: Quiet environment, single person speaking clearly',
  dragDropHint: 'Drag & drop file here or click to upload',
  uploading: 'Uploading...',
  uploadSuccess: 'Upload successful',
  fileName: 'File Name',
  duration: 'Duration',
  changeFile: 'Change File',
  removeFile: 'Remove',
  volume: 'Volume',
  speed: 'Speed',
  tone: 'Tone',
  
  //  Knowledge Base
  knowledgeBase: 'Knowledge Base Template Settings',
  development: 'Development',
  negotiation: 'Negotiation',
  sales: 'Sales',
  report: 'Report',
  supplement: 'Supplement',
  default: 'Default',
  custom: 'Custom',
  
  //  LLM Model
  llmSettings: 'LLM Settings',
  llmModelLabel: 'Select the large language model to use',
  
  //  Actions
  incomplete: 'Incomplete',
  savePersonality: 'Save AI Personality',
  saveSuccess: 'AI personality saved successfully!',
  deleteConfirm: 'Are you sure you want to delete this personality?',
  copySuccess: 'Personality copied successfully!',
};
